// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { VALID_TRANSITIONS, TERMINAL_STATUSES, SUB_STATUS_TO_STATUS } from '../constants/status.js';
/**
 * Check if a status transition is valid.
 * See: docs/backend/workflows.md - Transition Rules
 */
export function isValidTransition(from, to) {
    const allowed = VALID_TRANSITIONS[from];
    return allowed ? allowed.has(to) : false;
}
/**
 * Get the list of statuses reachable from the given status.
 */
export function getAllowedTransitions(from) {
    const allowed = VALID_TRANSITIONS[from];
    return allowed ? Array.from(allowed) : [];
}
/**
 * Check if a status is terminal (no further transitions allowed).
 */
export function isTerminalStatus(status) {
    return TERMINAL_STATUSES.has(status);
}
/**
 * Validate that a sub-status belongs to the given system status.
 * See: docs/backend/workflows.md - Sub-Status to System Status Mapping
 */
export function isValidSubStatus(status, subStatus) {
    return SUB_STATUS_TO_STATUS[subStatus] === status;
}
//# sourceMappingURL=transitions.js.map